// Local re-exports + helpers for the assistant module.
import {
  AgentContentBlock,
  AgentMessage,
  ChartSpec,
} from "../../../api/admin/types";

export type { AgentContentBlock, AgentMessage, ChartSpec };

export interface ParsedToolResult {
  // Either a chart_spec emitted by render_chart, an error, or arbitrary JSON
  // we can show as a debug payload.
  kind: "chart" | "error" | "json";
  chart?: ChartSpec;
  error?: string;
  json?: unknown;
}

export function parseToolResult(content: string): ParsedToolResult {
  let parsed: unknown;
  try {
    parsed = JSON.parse(content);
  } catch {
    return { kind: "json", json: content };
  }
  if (parsed && typeof parsed === "object") {
    const obj = parsed as Record<string, unknown>;
    if (obj.chart_spec) {
      return { kind: "chart", chart: obj.chart_spec as ChartSpec };
    }
    if (typeof obj.error === "string") {
      return { kind: "error", error: obj.error };
    }
  }
  return { kind: "json", json: parsed };
}
